<template>
  <v-container fluid grid-list-xl pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-toolbar-title>
        <v-flex pl-4>
          <v-combobox class="text-xs-left" name="commercialType" v-validate="'required'"
            :error-messages="errors.collect('select.commercialType')" v-model="commercialType" :items="items"
            item-text="title" :allow-overflow="false" type="button">
            <template slot="selection" slot-scope="data">
              <div>
                <span style="color:#005cae">{{ data.item.title }}</span>
              </div>
            </template>
          </v-combobox>
        </v-flex>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items style="margin-right:2%" v-if="commercialType.id != 1 && commercialType.id != 2 && commercialType.id != 3">
        <v-btn style="height:50%" class="hidden-xs-only" small @click="showGraphics(commercialType.id)"
          color="accent">Visualizar</v-btn>
        <!-- <v-btn @click="showGraphics(commercialType.id)" icon title="Visualizar">
          <v-icon color="primary">fa fa-eye</v-icon>
        </v-btn> -->

        <v-btn icon disabled>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-menu class="hidden-sm-and-up" style="margin-left: 4% !important;" bottom left>
          <v-btn slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="showGraphics(commercialType.id)">
              <v-list-tile-title>Visualizar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-card-text class="pt-0">
        <!-- <component v-bind:is="selectedComponent"></component> -->
        <CumplimientoPresupuesto v-if="commercialType.id == 1">
        </CumplimientoPresupuesto>
        <BonoNuevoRiesgo v-if="commercialType.id == 2">
        </BonoNuevoRiesgo>
        <PresupuestoRenovacionBonos v-if="commercialType.id == 3">
        </PresupuestoRenovacionBonos>
        <Pareto v-if="commercialType.id == 4"></Pareto>
        <Analysis-renovations v-if="commercialType.id == 5"></Analysis-renovations>
        <Accident-rate v-if="commercialType.id == 6"></Accident-rate>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

import Pareto from "./Pareto.vue";
import AnalysisRenovations from "./AnalysisRenovations.vue";
import AccidentRate from "./AccidentRate.vue";
import { EventBus } from "@/imports/EventBus";
import CumplimientoPresupuesto from "./CumplimientoPresupuesto.vue";
import BonoNuevoRiesgo from "./BonosNuevoRiesgo/BonoNuevoRiesgo.vue";
import PresupuestoRenovacionBonos from "./PresupuestoRenovacionBonos/PresupuestoRenovacionBonos.vue";

export default {
  components: {
    Pareto,
    AnalysisRenovations,
    AccidentRate,
    CumplimientoPresupuesto,
    BonoNuevoRiesgo,
    PresupuestoRenovacionBonos
  },
  computed: {

  },
  watch: {
    // commercialType(val) {
    //   this.selectedComponent = "Graphic" + val.id;
    // }
  },
  mounted() {
    this.$nextTick(() => {
      this.commercialType = this.items[0];
    });
  },
  methods: {
    showGraphics(id) {

      switch (id) {

        case 1:
          EventBus.$emit("WeeklyBudgetCompliance");
          break;
        case 2:
          EventBus.$emit("bonosNuevoRiesgo");
          break;
        case 3:
          EventBus.$emit("presupuestoRenovacionBonos");
          break;
        case 4:
          EventBus.$emit("Pareto");
          break;
        case 5:
          EventBus.$emit("AnalysisRenovations");
          break;
        case 6:
          EventBus.$emit("AccidentRate");
          break;
      }
    }
  },
  data() {
    return {
      items: [
        {
          id: 1,
          title: i18n.t("message.weeklyBudgetCompliance")
        },
        // {
        //   id: 2,
        //   title: i18n.t("message.bonosNuevoRiesgo")
        // },
        // {
        //   id: 3,
        //   title: i18n.t("message.presupuestoRenovacionBonos")
        // },
        // {
        //   id: 4,
        //   title: i18n.t("message.clientPareto")
        // },
        // {
        //   id: 5,
        //   title: i18n.t("message.graphAnalysisofRenovations")
        // },
        // {
        //   id: 6,
        //   title: i18n.t("message.accidentChart")
        // }
      ],
      commercialType: [],
      selectedComponent: ""
    };
  }
};
</script>